<template>
	<div>
		<ja-header
			ref="header"
			:title="$t('gamePlayMetaTitles.questionnaire')"
			subtitle="JA Finance Park"
		>
			<template v-slot:icon>
				<svgicon name="headerIcons/questionnaire"></svgicon>
			</template>
		</ja-header>
		<h1>{{ $t('studentInformation') }}</h1>
		<form class="user-information" autocomplete="off">
			<ja-input
				v-model.trim="studentName"
				class="form-input"
				name="studentName"
				:label="$t('studentName')"
				required
				:max-length="constants.FIRST_NAME_MAX_LENGTH"
				autocomplete="off"
				@input="updateFormData"
			></ja-input>
			<ja-input
				v-model.trim="schoolName"
				class="form-input"
				name="schoolName"
				:label="$t('schoolName')"
				required
				:max-length="constants.LAST_NAME_MAX_LENGTH"
				autocomplete="off"
				@input="updateFormData"
			></ja-input>
			<ja-input
				v-model.trim="educatorName"
				class="form-input"
				name="educatorName"
				:label="$t('educatorName')"
				required
				:max-length="constants.LAST_NAME_MAX_LENGTH"
				autocomplete="off"
				@input="updateFormData"
			></ja-input>
			<div class="button-wrapper">
				<ja-button
					class="large"
					name="information-next"
					:disabled="!onComplete"
					:aria-label="$t('goToQuestionnaire')"
					@click.native.prevent="saveInformation"
					>{{ $t('next') }}</ja-button
				>
			</div>
		</form>
	</div>
</template>

<script>
import gql from 'graphql-tag';
import NavigationLoading from '@/mixins/NavigationLoading';
import Header from '../components/ui/headers/Header';
import UserData from '../mixins/UserData';
import Input from '@/components/ui/form/Input';
import Button from '../components/ui/Button';

export default {
	components: {
		jaHeader: Header,
		jaInput: Input,
		jaButton: Button
	},
	mixins: [UserData, NavigationLoading],
	data() {
		return {
			studentName: '',
			schoolName: '',
			educatorName: '',
			onComplete: false
		};
	},
	computed: {
		userData() {
			return this.$store.getters.userData;
		},
		constants() {
			return this.$store.getters.constants;
		}
	},
	mounted() {
		this.$store.commit('setLoading', false);
	},
	created() {
		if (this.userData) {
			this.$store.dispatch('getPauseState');
		}
	},
	methods: {
		async saveInformation() {
			try {
				const studentInfo = {
					id: this.userData.studentId,
					formStudentName: this.studentName,
					formTeacherName: this.educatorName,
					formSchoolName: this.schoolName
				};
				const response = await this.$apollo.mutate({
					mutation: gql`
						mutation updateStudent($update: StudentInputObjectGraphType!) {
							updateIgnoreNullValuesStudent(update: $update) {
								id
							}
						}
					`,
					variables: {
						update: studentInfo
					}
				});
				if (response.data) {
					this.$store.commit('setLoading', true);
					this.$router.push({ name: 'pretest' });
				}
			} catch (error) {
				// eslint-disable-next-line no-console
				console.error(error);
			}
		},
		updateFormData() {
			this.onComplete =
				this.studentName.length > 0 &&
				this.schoolName.length > 0 &&
				this.educatorName.length > 0;
		}
	}
};
</script>
<style lang="scss" scoped>
.form-input {
	display: flex;
	flex-direction: column;
	margin-top: 16px;
	width: 500px;
}
.user-information {
	display: flex;
	align-items: center;
	flex-direction: column;
	margin-top: 32px;
}
h1 {
	text-align: center;
}
.button-wrapper {
	padding-top: 32px;
}
</style>
